<script>
import { JSONEditor } from '@json-editor/json-editor'

export default {
  name: 'json-editor',
  props: ['schema', 'valueProp'],
  data () {
    return {
      value: null
    }
  },
  watch: {
    computedSchema: {
      handler (schema) {
        const $this = this
        console.log('jsonEditor - watch() —— Schema', schema)
        if ($this.computedSchema) {
          $this.$nextTick(() => {
            $this.createEditor()
          })
        }
      }
    }
  },
  computed: {
    computedSchema () {
      const $this = this
      return $this.schema
    }
  },
  methods: {
    getOptions () {
      const defaults = {
        object_layout: 'format',
        show_errors: 'change',
        disable_array_add: false,
        disable_array_delete: false,
        disable_array_delete_all_rows: false,
        disable_array_delete_last_row: false,
        disable_array_reorder: false,
        disable_collapse: false,
        disable_edit_json: true,
        disable_properties: true,
        theme: 'barebones'
      }

      return Object.assign({}, defaults,  {
        onChange: this.onChange
      })
    },
    createEditor () {
      const $this = this

      const options = $this.getOptions()
      if ($this.schema !== null && $this.schema !== undefined) {
        console.log('createEditor() —— schema found', $this.schema)
        options.schema = $this.schema
      }

      // destroy old JSONEditor instance if exists
      if (window.jsonEditor) {
        console.log('createEditor() —— destroying old editor')
        window.jsonEditor.destroy()
      }

      const elem = document.getElementsByClassName('jsonEditor')[0]
      console.log('elem', elem)
      console.log('options', $this.getOptions())
      console.log('schema', $this.schema)
      console.log('value', $this.valueProp)

      if (elem && $this.schema !== null && $this.schema !== undefined) {
        // new instance of JSONEditor

        window.jsonEditor = new JSONEditor(elem, options)
        
        if ($this.valueProp && Object.keys($this.valueProp).length !== 0) {
          window.jsonEditor.setValue($this.valueProp)
          // needed for bug https://github.com/json-editor/json-editor/issues/159
        }

        // listen for changes
        window.jsonEditor.on('change', function () {
          const buttons = document.querySelectorAll('button[class*="json-editor-btn"]')
          for (let i = 0; i < buttons.length; i++) {
            buttons[i].className += ' vs-button vs-button-primary vs-button-filled small'
          }
          const v = window.jsonEditor.getValue()
          function valueCheck (v) {
            for (const key in v) {
              if (!v[key]) {
                v[key] = ''
              }
            }
          }
          valueCheck(v)

          // output
          $this.$emit('input', window.jsonEditor.getValue())
        })
      }

    },
    destroy () {
      if (window.jsonEditor !== null && window.jsonEditor !== undefined) {
        window.jsonEditor.destroy()
      }
    }
  },
  render (h) {
    return h('div', {
      class: 'jsonEditor'
    })
  },
  created () {
    const $this = this
    $this.createEditor()
  },
  beforeDestroy () {
    if (window.jsonEditor !== null) {
      window.jsonEditor.destroy()
      window.jsonEditor = null
    }
  }
}
</script>
<style>
  .jsonEditor .row div[data-schematype="array"] {
    margin-left: 15px !important;
  }
  button[class*='json-editor-btn'] {
    margin-top: 20px;
    margin-right: 10px;
  }
  .jsonEditor h3 {
    margin-top: 20px;
  }
  .jsonEditor h3 {
    margin-top: 20px;
  }
  .jsonEditor h3 > button {
    font-size: 10px !important;
  }
  .jsonEditor:first-child {
    margin-top: 1em;
  }
  .jsonEditor>div>h3 {
    display: none !important;
  }
  .jsonEditor>div>span {
    display: none;
  }
  .jsonEditor .row:first-child {
    margin: 1em 0 0;
  }
  .jsonEditor .row:not(:first-child) {
    margin-top: .5em;
  }
  .jsonEditor div {
      border-left: none !important;
      margin-left: 0px !important;
      padding-left: 0px !important;
  }
  .jsonEditor .form-control:focus-within label {
    color: rgba(var(--vs-primary),1);
  }
  .jsonEditor .form-control label {
    font-family:Montserrat, Helvetica, Arial, sans-serif;
    font-size:.85rem;
    font-weight:400;
    height:42px;
    left:0px;
    letter-spacing:0.16px;
    line-height:14.7px;
    padding-bottom:14px;
    padding-left:7px;
    padding-right:14px;
    padding-top:14px;
  }
  .jsonEditor .form-control input, .jsonEditor .form-control textarea, .jsonEditor select {
    border: 1px solid rgba(0, 0, 0, 0.2);
    padding: 1rem !important;
    font-size: 1.2rem !important;
    color: inherit;
    position: relative;
    border-radius: 5px;
    border: 1px solid rgba(0,0,0,.2);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-box-shadow: 0 0 0 0 rgba(0,0,0,.15);
    box-shadow: 0 0 0 0 rgba(0,0,0,.15);
    -webkit-transition: all .3s ease;
    transition: all .3s ease;
    width: 100%;
  }
  .jsonEditor .form-control input:focus, .jsonEditor .form-control textarea:focus, .jsonEditor .form-control select:focus {
    border: 1px solid rgba(var(--vs-primary),1)!important;
    -webkit-box-shadow: 0 3px 10px 0 rgba(0,0,0,.15);
    box-shadow: 0 3px 10px 0 rgba(0,0,0,.15);
    outline-offset: 0px;
  }
  .jsonEditor .form-control textarea {
    resize: none;
  }
  .jsonEditor select::-ms-expand {
    display: none;
  }
  .jsonEditor select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath fill='%23000000' d='M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z' /%3E%3C/svg%3E");  background-repeat: no-repeat;
    background-position: right .7em top 50%;
    background-size: 1em auto;
  }
  .jsonEditor .errmsg {
    font-size: .85em;
    float: right;
    color: rgba(0, 0, 0, 0.4);
  }
</style>
